import { c as _c } from "react/compiler-runtime";
// import "./BlogDigest.css"
// import { FocusedImage } from "../../component/FocusedImage/FocusedImage"
import Image from "next/image";
import isExternalLink from "../../utils/isExternalLink";
import { renderContentfulImage } from "../../utils/renderImage";
export interface LatestArticleProps {
  title: string;
  eyebrow: string;
  image: {
    src?: string;
    alt: string;
    x?: number;
    y?: number;
    title?: string;
    url?: string;
    height: number;
    width: number;
    focusArea?: string;
  };
  destination: string;
  excerpt: string;
  openInSameTabExternalLink?: boolean;
  componentImagePriority?: "high" | "auto" | "low";
}

// const latestArticleImageSizes = {
//   desktop: {
//     width: 1440,
//     height: 810,
//     ratio: {
//       width: 16,
//       height: 7,
//     },
//   },
//   tablet: {
//     width: 1440,
//     height: 810,
//     ratio: {
//       width: 16,
//       height: 16,
//     },
//   },
//   mobile: {
//     width: 520,
//     height: 480,
//     ratio: {
//       width: 13,
//       height: 12,
//     },
//   },
// }

export const LatestArticle = t0 => {
  const $ = _c(23);
  const {
    eyebrow,
    title,
    image,
    destination,
    excerpt,
    openInSameTabExternalLink: t1,
    componentImagePriority
  } = t0;
  const openInSameTabExternalLink = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== componentImagePriority || $[1] !== image) {
    t2 = () => {
      if (image?.x !== undefined && image?.y !== undefined) {
        return renderContentfulImage(image.url || "", image.alt || "", 630, 380, "", 95, image.focusArea, componentImagePriority);
      } else {
        if (image?.src) {
          return <><Image className="t2-lo-general__image" src={image.src} width={image.width || 630} height={image.height || 380} alt={image.alt || ""} priority={componentImagePriority === "high"} /></>;
        }
      }
    };
    $[0] = componentImagePriority;
    $[1] = image;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const renderImage = t2;
  let linkTarget = isExternalLink(destination) ? "_blank" : "_self";
  linkTarget = openInSameTabExternalLink ? "_self" : linkTarget;
  const t3 = linkTarget;
  const t4 = linkTarget === "_blank" ? "noopener noreferrer" : undefined;
  let t5;
  if ($[3] !== renderImage) {
    t5 = renderImage();
    $[3] = renderImage;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="overflow-hidden w-full h-96 mb-8 max-lg:h-[420px] max-sm:h-60">{t5}</div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== eyebrow) {
    t7 = <h2 className="text-blue-trmb uppercase text-lg font-bold leading-7 tracking-tight max-sm:text-sm max-sm:leading-relaxed max-sm:tracking-tight t2-dark:text-white">{eyebrow}</h2>;
    $[7] = eyebrow;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== title) {
    t8 = <h3 className="text-gray-m9 text-xl font-bold leading-relaxed mt-1.5 mb-5 t2-dark:text-white">{title}</h3>;
    $[9] = title;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== excerpt) {
    t9 = excerpt && <p className="text-gray-m9 text-base font-normal leading-6 tracking-normal m-0 t2-dark:text-white">{excerpt?.substring(0, 125)}...</p>;
    $[11] = excerpt;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <div className="">{t7}{t8}{t9}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== destination || $[18] !== linkTarget || $[19] !== t10 || $[20] !== t4 || $[21] !== t6) {
    t11 = <div className="min-w-[630px] max-sm:w-full max-sm:min-w-0 hover:underline"><a href={destination} target={t3} rel={t4} className="no-underline">{t6}{t10}</a></div>;
    $[17] = destination;
    $[18] = linkTarget;
    $[19] = t10;
    $[20] = t4;
    $[21] = t6;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};